import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, Validators } from "@angular/forms";
import { AuthService } from "../auth.service";
import { BehaviorSubject } from "rxjs";
import { UsersService } from "../../users/users.service";
import { switchMap, take } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SNACKBAR_USER_ERROR } from "../../../locale/consts.en";
import { ADMIN_UUID } from "../../users/users.model";

@Component({
    selector: "app-login-page",
    templateUrl: "./login-page.component.html",
    styleUrls: ["./login-page.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginPageComponent implements OnDestroy {
  private router = inject(Router);
  private snackBar = inject(MatSnackBar);
  private userService = inject(UsersService);
  private authService = inject(AuthService);
  private formBuilder = inject(FormBuilder);


  loading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  loginForm = this.formBuilder.group({
    email: ["", [Validators.required, Validators.email]],
    password: ["", [Validators.required]],
  });

  login() {
    this.loading.next(true);
    const email = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    this.authService
      .login({ email, password })
      .then(() => {
        this.userService
          .getUserUuid(this.authService.user.uid)
          .pipe(
            take(1),
            switchMap((uuid) => this.userService.getUserData(uuid))
          )
          .subscribe((resp) => {
            if (
              resp === null ||
              resp.enabled === false ||
              !resp.roles.map((r) => r.uuid)?.includes(ADMIN_UUID)
            ) {
              this.snackBar.open(SNACKBAR_USER_ERROR, "", { duration: 2000 });
              this.authService.logout();
            } else {
              this.router.navigate(["/"]).then();
            }
          });

        this.loading.next(false);
      })
      .catch((error) => {
        this.loading.next(false);
        console.log("User error", error);
      });
  }

  ngOnDestroy(): void {
    this.loading.next(false);
    this.loading.complete();
  }
}
